import React from 'react'
import { useLocation } from 'react-router-dom'
import NeutralMark from './NeutralMark'
import { CLIENT_PORTAL_LABEL, TEAM_PORTAL_LABEL, isTeamPath } from '../../lib/portalAudience'

const NeutralPortalHeader = () => {
  const { pathname } = useLocation()

  return (
    <div className="na-portal-header">
      <NeutralMark size={32} />
      <span>{isTeamPath(pathname) ? TEAM_PORTAL_LABEL : CLIENT_PORTAL_LABEL}</span>
    </div>
  )
}

export default NeutralPortalHeader
